import { ArgumentParsingError } from './exceptions/argument-parsing-error';
import { ArgumentPointerError } from './exceptions/argument-pointer-error';
import { InvalidArgumentError } from './exceptions/invalid-argument-error';
import { ParsingError } from './exceptions/parsing-error';
import { getIndexByArgumentRoot } from './helpers/get-index-by-argument-root';
import { getValueByArgumentProps } from './helpers/get-value-by-argument-props';
import { isValidArgument } from './helpers/is-valid-argument';
import type { TArg, TEventOptions, TReplacer } from './models';

const DEFAULT_ARGS: TArg[] = [];
const DEFAULT_GLOBAL_ARG = '$window';

export const createReplacer =
    (
        { args = DEFAULT_ARGS, globalArg = DEFAULT_GLOBAL_ARG }: TEventOptions,
        params?: unknown[]
    ): TReplacer =>
    (arg: TArg) => {
        const [root, ...props] = arg.split('.');

        if (!isValidArgument([...args, globalArg], root)) throw new InvalidArgumentError(arg);

        try {
            if (root === globalArg) return getValueByArgumentProps(window, props);

            const argIndex = getIndexByArgumentRoot(args, root);

            if (!params || argIndex >= params.length || argIndex < 0)
                throw new ArgumentPointerError(arg);

            return getValueByArgumentProps(params[argIndex], props);
        } catch (e) {
            if (e instanceof ParsingError) throw e;

            throw new ArgumentParsingError(arg);
        }
    };
